export const PLATFORM_VALUE = {
  INS: 11,
  WEIBO: 20,
  BRAND: 9,
  SHOW: 2,
  ITEM: 8,
  UPLOAD: 26,
  WHOLESALE: 7,
  RETAIL: 6,
  XIAOHONGSHU: 37,
  DY: 18,
  DY_WORKS: 19,
  DW: 38,
  DW_GOODS: 45,
  JP: 39,
  CROSSBORDER: 100,
  DHH: 40,
  INSGOODS: 41,
  PORTER: 42,
  FARFETCH: 43,
  SSENSE: 44,
  SHOPBOP: 48,
  XIU_CHANGE_XI_JIE: 46,
  SHI_ZHUANG_DA_PIAN: 47,
  CROSSBORDER_INS: 97,
  CROSSBORDER_INS_GOODS: 98,
  CROSSBORDER_SHOW: 99,
  CROSSBORDER_PINTEREST: 96,
  ZHI_XIAO_HONG: 49,
  TAOBAO_ZHI_DA: 571,
  COLLECT_PLUG: 27,
  PINTEREST: 50,
  MUSINSA: 51
}

// top10TypeOptions 选款分析top10下的来源tab配置项
// 1-淘宝店铺 2-ins博主 3-小红书博主 4-品牌 5-抖音达人 6-抖音小店 7-跨境站点 8-用户插件采集站点
export enum TOP_10_TYPE_ENUM {
  'TAO_BAO_DIAN_PU' = 1,
  'INS_BO_ZHU' = 2,
  'XIAO_HONG_SHU_BO_ZHU' = 3,
  'PIN_PAI' = 4,
  'DY_DA_REN' = 5,
  'DY_DIAN_PU' = 6,
  'KUA_JING_ZHAN_DIAN' = 7,
  'CAI_JI_ZHAN_DIAN' = 8,
}
// const brand = { label: '品牌', value: TOP_10_TYPE_ENUM.PIN_PAI }
// const brandTop10TypeOptions = [brand]

export const PLATFORM_CONFIG_ENUM = new Map([
  [PLATFORM_VALUE.INS, { label: 'INS款式', value: PLATFORM_VALUE.INS, dto: 'insDataDTO' }],
  [PLATFORM_VALUE.WEIBO, { label: '微博', value: PLATFORM_VALUE.WEIBO, dto: 'weiboDataDTO' }],
  [PLATFORM_VALUE.BRAND, { label: '品牌预售', value: PLATFORM_VALUE.BRAND, dto: 'brandSelectedDataDTO' }],
  [PLATFORM_VALUE.SHOW, { label: '秀场', value: PLATFORM_VALUE.SHOW, dto: 'runwayDataDTO' }],
  [PLATFORM_VALUE.ITEM, { label: '淘系', value: PLATFORM_VALUE.ITEM, dto: 'itemDataDTO', top10TypeOptions: [{ label: '店铺', value: TOP_10_TYPE_ENUM.TAO_BAO_DIAN_PU }, { label: '品牌', value: TOP_10_TYPE_ENUM.PIN_PAI }] }],
  [PLATFORM_VALUE.UPLOAD, { label: '上传灵感', value: PLATFORM_VALUE.UPLOAD, dto: 'userUploadDataDTO' }],
  [PLATFORM_VALUE.WHOLESALE, { label: '批发市场', value: PLATFORM_VALUE.WHOLESALE, dto: 'wholesaleDataDTO' }],
  [PLATFORM_VALUE.RETAIL, { label: '零售市场', value: PLATFORM_VALUE.RETAIL, dto: 'retailDataDTO' }],
  [PLATFORM_VALUE.XIAOHONGSHU, { label: '小红书', value: PLATFORM_VALUE.XIAOHONGSHU, dto: 'xhsDataDTO' }],
  [PLATFORM_VALUE.DY, { label: '抖衣', value: PLATFORM_VALUE.DY, dto: 'dyItemDataDTO', top10TypeOptions: [{ label: '店铺', value: TOP_10_TYPE_ENUM.DY_DIAN_PU }, { label: '品牌', value: TOP_10_TYPE_ENUM.PIN_PAI }] }],
  [PLATFORM_VALUE.DY_WORKS, { label: '抖衣作品', value: PLATFORM_VALUE.DY_WORKS, dto: 'dyVideoDataDTO' }],
  [PLATFORM_VALUE.DW, { label: '得物', value: PLATFORM_VALUE.DW, dto: 'dewuDataDTO' }],
  [PLATFORM_VALUE.DW_GOODS, { label: '得物商品', value: PLATFORM_VALUE.DW_GOODS, dto: 'dewuItemInfoDTO' }],
  [PLATFORM_VALUE.JP, { label: '街拍', value: PLATFORM_VALUE.JP, dto: 'streetSnapDataDTO' }],
  [PLATFORM_VALUE.DHH, { label: '订货会', value: PLATFORM_VALUE.DHH, dto: 'dhhDataDTO' }],
  [PLATFORM_VALUE.INSGOODS, { label: 'INS商品', value: PLATFORM_VALUE.INSGOODS, dto: 'insItemDataDTO' }],
  [PLATFORM_VALUE.PORTER, { label: 'NET-A-PORTER', value: PLATFORM_VALUE.PORTER, dto: 'porterDataDTO' }],
  [PLATFORM_VALUE.FARFETCH, { label: '发发奇', value: PLATFORM_VALUE.FARFETCH, dto: 'farfetchDataDTO' }],
  [PLATFORM_VALUE.SSENSE, { label: 'SSENSE', value: PLATFORM_VALUE.SSENSE, dto: 'ssenseDataDTO' }],
  [PLATFORM_VALUE.SHOPBOP, { label: 'shopbop', value: PLATFORM_VALUE.SHOPBOP, dto: 'shopbopDataDTO' }],
  [PLATFORM_VALUE.XIU_CHANGE_XI_JIE, { label: '秀场细节', value: PLATFORM_VALUE.XIU_CHANGE_XI_JIE, dto: 'runwayDetailDataDTO' }],
  [PLATFORM_VALUE.SHI_ZHUANG_DA_PIAN, { label: '时装大片', value: PLATFORM_VALUE.SHI_ZHUANG_DA_PIAN, dto: 'fashionMasterpieceDataDTO' }],
  [PLATFORM_VALUE.ZHI_XIAO_HONG, { label: '知小红', value: PLATFORM_VALUE.ZHI_XIAO_HONG, dto: 'zxhBlogDataDTO' }],
  [PLATFORM_VALUE.CROSSBORDER, { label: '海外探款', value: PLATFORM_VALUE.CROSSBORDER, dto: 'crossBorderDTO' }],
  [PLATFORM_VALUE.CROSSBORDER_INS_GOODS, { label: '海外探款-INS商品', value: PLATFORM_VALUE.CROSSBORDER_INS_GOODS, dto: 'insItemDataDTO' }],
  [PLATFORM_VALUE.CROSSBORDER_INS, { label: '海外探款-INS款式', value: PLATFORM_VALUE.CROSSBORDER_INS, dto: 'insDataDTO' }],
  [PLATFORM_VALUE.CROSSBORDER_SHOW, { label: '海外探款-秀场', value: PLATFORM_VALUE.CROSSBORDER_SHOW, dto: 'runwayDataDTO' }],
  [PLATFORM_VALUE.CROSSBORDER_PINTEREST, { label: '海外探款-Pinterest', value: PLATFORM_VALUE.CROSSBORDER_PINTEREST, dto: 'pinterestAbroadDataDTO' }],
  [PLATFORM_VALUE.TAOBAO_ZHI_DA, { label: '淘系搭配', value: PLATFORM_VALUE.TAOBAO_ZHI_DA, dto: 'zhiDaBlogDataDTO' }],
  [PLATFORM_VALUE.COLLECT_PLUG, { label: '采集插件', value: PLATFORM_VALUE.COLLECT_PLUG, dto: 'pluginUploadDataDTO' }],
  [PLATFORM_VALUE.PINTEREST, { label: 'Pinterest', value: PLATFORM_VALUE.PINTEREST, dto: 'pinterestDataDTO' }],
  [PLATFORM_VALUE.MUSINSA, { label: 'MUSINSA', value: PLATFORM_VALUE.MUSINSA, dto: 'musinsaDataDTO' }],
])

// export const SHARE_TEXT = {
//   0: '不共享',
//   1: '部分成员可见',
//   2: '全员可见'
// }

export const INDUSTRY = { CLOTHING: '服装', SHOES: '鞋靴' }

export const GENDER_VALUE = {
  WOMEN: '女装',
  MEN: '男装',
  CHILD: '童装',
  GIRL: '女童',
  BOY: '男童',
  SHOES: '鞋靴'
}
export const GENDER_OPTIONS = [
  {
    value: '女装',
    label: '女装'
  },
  {
    value: '男装',
    label: '男装'
  },
  {
    value: '童装',
    label: '童装'
  },
  {
    value: '女童',
    label: '女童'
  },
  {
    value: '男童',
    label: '男童'
  },
  {
    value: '鞋靴',
    label: '鞋靴'
  },
  {
    value: '其他',
    label: '其他'
  },
]
export const INDUSTRY_VALUE = {
  [GENDER_VALUE.WOMEN]: '服装',
  [GENDER_VALUE.MEN]: '服装',
  [GENDER_VALUE.CHILD]: '服装',
  [GENDER_VALUE.GIRL]: '服装',
  [GENDER_VALUE.BOY]: '服装',
  [GENDER_VALUE.SHOES]: '鞋靴'
}
export const MARK_STATUS = { UNSET: 0, PASS: 1, NOT_PASS: 2, PENDING: 3 }
export const MARK_TEXT = {
  [MARK_STATUS.UNSET]: '待提审',
  [MARK_STATUS.PASS]: '通过',
  [MARK_STATUS.NOT_PASS]: '拒回',
  [MARK_STATUS.PENDING]: '待审核',
}
export const QUERY_TYPE = {
  /**
   * 拥有
   */
  OWNER: 1,
  /**
   * 协作
   */
  COOPERATION: 2,
  /**
   * 全部
   */
  ALL: 3
}
export const getMarkStatusText = (markStatus, option:any) => {
  const { level = 0, maxLevel = 0, isPass = false, isNotPass = false } = option || {}

  if (isPass) {
    if (markStatus === MARK_STATUS.PASS) {
      return true
    }
    return false
  }

  if (isNotPass) {
    if (maxLevel === level && markStatus === MARK_STATUS.NOT_PASS) {
      return true
    }
    return false
  }

  const levelEnum = {
    1: '一',
    2: '二',
    3: '三',
    4: '四',
    5: '五',
    6: '六',
    7: '七',
    8: '八',
    9: '九'
  }

  if (markStatus === MARK_STATUS.PASS || markStatus === MARK_STATUS.NOT_PASS) {
    if (markStatus === MARK_STATUS.PASS) {
      return '已通过'
    }
    if (markStatus === MARK_STATUS.NOT_PASS && (level === maxLevel || level === 0)) {
      return '已拒回'
    }
    if (markStatus === MARK_STATUS.NOT_PASS && level !== 0) {
      return `${levelEnum[level]}审${MARK_TEXT[MARK_STATUS.NOT_PASS]}`
    }
  }
  if ((markStatus === MARK_STATUS.UNSET || markStatus === MARK_STATUS.PENDING || markStatus === MARK_STATUS.NOT_PASS) && level !== 0) {
    return `${levelEnum[level]}审${MARK_TEXT[MARK_STATUS.PASS]}`
  }
  return MARK_TEXT[markStatus]
}

export const MEMBER_TYPE = {
  SUPER_ADMIN: 1,
  ADMIN: 2,
  MEMBER: 3
}
export const IDEA_MASS_ROLE = {
  OWNER: 2,
  AUDITOR: 1,
  GATHER: 3,
  VIEWER: 4,
  UNSET: 0,
  VISITOR: -1
} // 2-拥有者，1-审核者, 3-采集者，4-查看者，0-初始化值，-1 访客

export const ROLE_COMPARISON = {
  [IDEA_MASS_ROLE.OWNER]: '拥有者',
  [IDEA_MASS_ROLE.AUDITOR]: '审核者',
  [IDEA_MASS_ROLE.GATHER]: '采集者',
  [IDEA_MASS_ROLE.VIEWER]: '查看者',
}
